export { default } from './AlertBuyingForContainer';
